import { PriceMobile, MappedPriceMobile } from '@vpp-frontend-components/price';

export default PriceMobile;
export const MappedPrice = MappedPriceMobile;
